module.exports = __webpack_public_path__ + "static/media/marker.fcee1ff2.svg";